import React, { FC } from 'react'
import { TextBox, TextBoxProps } from '@ds/ui'

interface ExtensionProps extends TextBoxProps {
  /** The text to display in the input. */
  value: string
  /** Fired when user updates the input text. Will not fire for disallowed characters. */
  onChangeText: (
    value: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  /** Instructs the browser to offer suggestions for the phone number and extension fields, based on the user's previous entries. */
  autofill?: boolean
}

/**
 * Renders an input for phone number extension.
 *
 * @param props
 */
export const Extension: FC<ExtensionProps> = ({
  value,
  onChangeText,
  autofill,
  maxLength = 20,
  ...restProps
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: eventValue } = event.target
    const cleanedInput = eventValue.replace(/\D/g, '')

    if (cleanedInput !== value) {
      onChangeText(cleanedInput, event)
    }
  }

  return (
    <TextBox
      {...restProps}
      value={value}
      onChange={handleChange}
      maxLength={maxLength}
      autoCapitalize="off"
      spellCheck="false"
      autoComplete={autofill ? 'tel-extension' : 'off'}
    />
  )
}
